import { AnyAction, Reducer } from 'redux';

import { mapIdToData } from '~src/utils';
import {
  DELETE_ANSWER_SUCCESS,
  GET_QUESTIONS_FAILED,
  GET_QUESTIONS_REQUEST,
  GET_QUESTIONS_SUCCESS,
  UPDATE_QUESTION_SUCCESS,
} from '~src/modules/questions/constants/actionTypes';

import { CardI, emptyAnswer } from '~src/interfaces/question.interface';

import { StoreI } from '~src/rootReducer';

export interface QuestionsState {
  loading: boolean;
  error: Error | null;
  byId: Record<string, CardI>;
}

export function getInitialQuestionsState(): QuestionsState {
  return {
    loading: false,
    error: null,
    byId: {},
  };
}

const questionsReducer: Reducer<QuestionsState, AnyAction> = (state = getInitialQuestionsState(), action) => {
  switch (action.type) {
    case GET_QUESTIONS_REQUEST: {
      return { ...state, loading: true };
    }
    case GET_QUESTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        byId: mapIdToData(action.response.data),
      };
    }
    case GET_QUESTIONS_FAILED: {
      return { ...state, loading: false, error: action.payload };
    }
    case UPDATE_QUESTION_SUCCESS: {
      return { ...state, loading: false };
    }
    case DELETE_ANSWER_SUCCESS: {
      return {
        ...state,
        byId: { ...state.byId, [action.id]: { ...state.byId[action.id], answer: emptyAnswer() } },
      };
    }
    default:
      return state;
  }
};

export function getQuestions(state: StoreI) {
  return Object.values(state.user.questions.byId);
}

export default questionsReducer;
